import { SASHEC_DEVICES } from '../../constants'

export function detectSashecDevice () {
  let fittingDevice

  if (typeof window !== 'undefined') {
    const viewPortWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    fittingDevice = Object.keys(SASHEC_DEVICES).find(sashecDevice => {
      return viewPortWidth >= SASHEC_DEVICES[sashecDevice]
    })
  }

  return fittingDevice
}

export function sashecReloadPosition (targetId, pos) {
  if (window._sashec) {
    const adPosition = window._sashec.getPositionsByElementId(targetId)[0]
    if (adPosition) {
      window._sasic_queue.push(['position', {
        elementId: adPosition.elementId,
        groupId: adPosition.groupId,
        options: {
          targets: {
            pos: pos
          }
        }
      }])
      adPosition.load()
    }
  }
}

function isWindow () {
  return typeof window !== 'undefined'
}

export function sashecQueuePush (payload) {
  if (isWindow()) {
    window._sashec_queue = window._sashec_queue || []
    window._sashec_queue.push(payload)
  }
}
